import { render, staticRenderFns } from "./superFloor.vue?vue&type=template&id=0b255528&scoped=true"
import script from "./superFloor.vue?vue&type=script&lang=js"
export * from "./superFloor.vue?vue&type=script&lang=js"
import style0 from "./superFloor.vue?vue&type=style&index=0&id=0b255528&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b255528",
  null
  
)

export default component.exports